module.exports = __webpack_public_path__ + "img/2.c560b465.jpg";